import { ETimeSlot } from "./enum/time-slot";
import { ClientMeasure } from "./client-measure";
import { SamplingPoint } from "./sampling-point";
import { User } from "./user";
import { ISelectable } from "../tools/selectable";
import { EInterventionStatus } from "./enum/intervention-status";
import { Competence } from "./competence";
import { DisponibiliteClient } from "./disponibilite-client";
import { AreaMap } from "./GS/area-map";


export class Intervention extends ISelectable {
    constructor() {
        super();
        this.DisponibiliteClientList.push(new DisponibiliteClient())
    }

    Id: number;
    StrategyId: number;
    RequiredOn: Date;// = new Date();
    PlannedOn: Date;
    CreadtedBy: string;
    Comment: string;
    /** All kind of measure coming from the server */
    MeasureList: ClientMeasure[] = [];
    SamplingPoint: SamplingPoint;
    Status: EInterventionStatus;

    SiteContact: User;
    // Dispatch
    EDIOrderNumber: string;
    DispatchComment: string;
    SamplingAgencyName: string;
    Duration: number;
    //
    CompetenceList: Competence[] = [];
    DisponibiliteClientList: DisponibiliteClient[] = [];
    // DEBUG
    wn: number;
    //
    /** BORDEREAU DE COMMANDE POUR CERTAIN CLIENT */
    OrderFileName: string;
    IsDeposeJ0: boolean;
    IsQuotationExpired: boolean = false;
    IsSamplingPointMissing: boolean = false;
    IsQuotationMissing: boolean = false;

    IsClientBlocked: boolean = false;

    // USED GS AREAMAP TO ATTACH MAP INTO INTERVENTION FOR LINGETTE
    LingetteAreaMapIdList: number[] = [];
    // GET MAP TERRAIN LIST FOR LINGETTE
    LingetteAreaMapTerrainList: AreaMap[] = [];

    // USED GS AREAMAPTO ATTACH MAP INTO INTERVENTION FOR MASSIF
    MassifAreaMapIdList: number[] = [];
    // GET MAP TERRAIN LIST FOR MASSIF
    MassifAreaMapTerrainList: AreaMap[] = [];

    static mapFromJSON(json) {
        const i = new Intervention();

        i.Id = json['id'];
        i.Status = json['status'];
        i.StrategyId = json['strategyId'];
        i.RequiredOn = new Date(json['requiredOn']);
        i.PlannedOn = new Date(json['plannedOn']);
        i.CreadtedBy = json['createdBy'];
        i.Duration = json['duration'];
        i.Comment = json['comment'];
        i.DispatchComment = json['dispatchComment'];
        i.EDIOrderNumber = json['ediOrderNumber'];
        i.SamplingAgencyName = json['samplingAgencyName'];
        i.IsDeposeJ0 = json['isDeposeJ0'];
        i.IsQuotationExpired = json['isQuotationExpired'];
        i.IsSamplingPointMissing = json['isSamplingPointMissing'];
        i.IsQuotationMissing = json['isQuotationMissing'];
        i.IsClientBlocked = json['isClientBlocked'];

        if (json['lingetteAreaMapTerrainList']) {
            i.LingetteAreaMapTerrainList = json['lingetteAreaMapTerrainList'].map(item => AreaMap.mapFromJSON(item));
        }
        if (json['massifAreaMapTerrainList']) {
            i.MassifAreaMapTerrainList = json['massifAreaMapTerrainList'].map(item => AreaMap.mapFromJSON(item));
        }
        if (json['competenceList']) {
            i.CompetenceList = json['competenceList'].map(item => Competence.mapFromJSON(item));
        }
        if (json['clientMeasures']) {
            i.MeasureList = json['clientMeasures'].map(item => ClientMeasure.mapFromJSON(item));
        }
        if (json['disponibiliteClientList']) {
            i.DisponibiliteClientList = json['disponibiliteClientList'].map(item => DisponibiliteClient.mapFromJSON(item));
        }
        if (json['samplingPoint']) {
            i.SamplingPoint = SamplingPoint.mapFromJSON(json['samplingPoint']);
        }

        if (json['siteContact']) {
            i.SiteContact = User.mapFromJSON(json['siteContact']);
        }

        return i;
    }
}
